import React from 'react';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import 'classnames';
import '../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../common/Icon/index.js';
import '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import '../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const ShineIcon = () => /* @__PURE__ */ React.createElement("div", { className: styles["shine-box"] }, /* @__PURE__ */ React.createElement(Icon, { iconName: "Shine" }));
ShineIcon.displayName = "ShineIcon";

export { ShineIcon };
//# sourceMappingURL=Shine.js.map
